import CountUp from './CountUp';

const Stats = () => {
  const stats = [
    { value: 29, suffix: '+', label: 'År av Erfarenhet' },
    { value: 10000, suffix: '+', label: 'Nöjda Kunder', separator: ',' },
    { value: 98, suffix: '%', label: 'Kundnöjdhet' },
    { value: 100, suffix: '%', label: 'Miljövänliga Produkter' },
  ];

  return (
    <section className="py-20 bg-red-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold mb-2">
                <CountUp
                  from={0}
                  to={stat.value}
                  duration={1.2}  // Reduced from 2s to 1.2s for faster counting
                  delay={index * 0.15}  // Reduced delay between items
                  className="inline-block"
                  separator={stat.separator}
                />
                {stat.suffix}
              </div>
              <div className="text-lg md:text-xl opacity-90">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
